import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'
import ImgUtil from '../../../utils/img.utils'

export const FeaturedSliderStyle = styled.div`
  opacity: 0;
  transform: translateY(100%);
  transition: all 0.3s ease-in-out;

  &.FeaturedSlider--Visible {
    transform: translateY(0%);
    opacity: 1;
  }

  &.rightSide {
    right: 0;
    left: auto;
  }

  a.CTA {
    position: relative;
    z-index: 9;
  }

  &:before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    background-image: url(${ImgUtil.getResizedImageUrl(ASSETS.TRANSPARENT_MACS, '')});
    background-repeat: no-repeat;
    height: 100%;
    background-position: center;
    background-size: cover;
  }

  &:after {
    content: '';
    position: absolute;
    top: -81px;
    left: 20px;
    object-fit: cover;
    background-image: url(${ImgUtil.getResizedImageUrl(ASSETS.FEATURED_SLIDER_ROBOT, '')});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    width: 133px;
    height: 148px;
  }

  position: fixed;
  z-index: 10000;
  bottom: 0;
  left: 64px;
  width: 500px;

  background: ${({ theme }) => theme.webMktNewPalette.orange[50]};
  padding: 46px 40px 40px;
  box-sizing: border-box;

  .FeaturedSlider__Headline,
  .FeaturedSlider__Subheadline {
    margin-bottom: 0;
    color: ${({ theme }) => theme.webMktNewPalette.white};
  }

  .FeaturedSlider__Headline {
    margin-top: 17px;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -1px;
    font-weight: 600;
  }

  .FeaturedSlider__Subheadline {
    margin-top: 8px;
    margin-bottom: 24px;
    position: relative;
    z-index: 9;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 47px 24px 40px;
    min-height: 353px;
    max-width: 480px;
  }

  .FeaturedSlider__Confirm {
    > h4 {
      color: ${({ theme }) => theme.webMktNewPalette.white};
    }

    display: none;
  }

  @media screen and (max-width: 564px) {
    left: 0;
  }

  .FeaturedSlider__Close-Icon {
    position: absolute;
    top: 22px;
    right: 24px;
    width: 18px;
    height: 18px;
    pointer-events: auto;
    cursor: pointer;
    opacity: 0.5;

    &:hover {
      opacity: 1;
    }
  }
`
